import React, { Component } from "react";
import profile from "../../assets/images/Oval.png";
import { Divider } from "antd";

class TvScreen3 extends Component {
  qpatientdetails = () => (
    <div>
      <div className="patientQDetailsdiv3">
        <div className="col-5 qDocDetails3">
          <img alt="" src={profile} class="qdoctorImg3" />
          <div className="qDoc3">
            <span class="qdoctorFonts qdoctor">Dr. Anil Doctor3</span>
            <span class="qdoctorFonts qdoctorProfq">Cardiologist</span>
          </div>
        </div>
        <span class="col-3 patientQHeaderTitles3 TVRoom3val">12</span>
        <span class="col-2 patientQHeaderTitles3 TVCurrent3val">00129</span>
        <span class="col-2 patientQHeaderTitles3 TVNext3val">01120</span>
      </div>
      {/* <div class="Line3" /> */}
      <Divider />
    </div>
  );
  render() {
    return (
      <div className="tvScreen3">
        <div className="patientQHeader3">
          <span class="col-5 patientQHeaderTitles3 TVDoctor3">Doctor</span>
          <span class="col-3 patientQHeaderTitles3 TVRoom3">Room No.</span>
          <span class="col-2 patientQHeaderTitles3 TVCurrent3">Current</span>
          <span class="col-2 patientQHeaderTitles3 TVNext3">Next</span>
        </div>
        <div className="patientQDetails3">
          {this.qpatientdetails()}
          {this.qpatientdetails()}
          {this.qpatientdetails()}
          {this.qpatientdetails()}
          {this.qpatientdetails()}
          {this.qpatientdetails()}
        </div>
      </div>
    );
  }
}
export default TvScreen3;
